export const NEWS_RECEIVED = 'NEWS_RECEIVED'

export function newsReceived(news) {
  return {
    type: NEWS_RECEIVED,
    news
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/news.js
 **/